/**************************************************
 * Nombre:       Formulario_Datos_Pasos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {BorderColor, FilterAltOutlined, Looks3Outlined, Redo, Title, Undo} from "@mui/icons-material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoTextoLista from "../../../Modulo_formularios/Componentes/IngresoTextoLista";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Indicadores from "./Formulario_Indicadores";
import Tarjeta_Indicador from "../../Tarjetas/Tarjeta_Indicador";
import Formulario_Pasos from "./Formulario_Pasos";
import Tarjeta_Paso from "../../Tarjetas/Tarjeta_Paso";
import Formulario_Pregunta from "./Formulario_Pregunta";
import Tarjeta_Pregunta from "../../Tarjetas/Tarjeta_Pregunta";

const Formulario_Datos_Pasos = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        Tarjeta: Tarjeta_Indicador,
        Formulario: Formulario_Indicadores,
        nombre: 'Agregar Indicador',
        dato: 'indicadores'
    });
    const {IngresarObjeto: IngresoPaso} = useIngresarObjeto({
        props: props,
        Tarjeta: Tarjeta_Paso,
        Formulario: Formulario_Pasos,
        nombre: 'Agregar Paso',
        dato: 'pasos'
    });
    const {IngresarObjeto: IngresoPreguntas} = useIngresarObjeto({
        props: props,
        Tarjeta: Tarjeta_Pregunta,
        Formulario: Formulario_Pregunta,
        nombre: 'Agregar Pregunta',
        dato: 'preguntas'
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >





                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Title} nombre={'Titulo De Pasos'} {...props}
                                  dato={'tituloPasos'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={BorderColor} nombre={'Titulo Resaltado De Pasos'} {...props}
                                  dato={'rosadoTituloPasos'}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 2}}>
                    <Typography>Ingreso Pasos</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoPaso/>
                </Grid>

                {/*<Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Title} nombre={'Titulo De Testimonios'} {...props}
                                  dato={'tituloTestimonios'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={BorderColor} nombre={'Titulo Resaltado De Testimonios'} {...props}
                                  dato={'rosadoTituloTestimonios'}/>
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={3} nombre={'Parrafo De Testimonios'} {...props}
                                  dato={'parrafoTestimonios'}/>
                </Grid>*/}


            </Grid>

        </form>

    )

}
export default Formulario_Datos_Pasos